import React from 'react';
import { Box, Typography, Grid, Paper, useTheme, Container } from '@mui/material'; // Added Container import
import GroupIcon from '@mui/icons-material/Group';
import LightbulbOutlineIcon from '@mui/icons-material/LightbulbOutline';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';

const steps = [
    { 
        icon: GroupIcon, 
        title: "Join Community Rooms", 
        description: "Connect with neighbors and peers sharing real experiences on vital topics." 
    },
    { 
        icon: LightbulbOutlineIcon, 
        title: "Access Knowledge", 
        description: "Get summaries and context from our AI to bridge information gaps quickly." 
    },
    { 
        icon: VolunteerActivismIcon, 
        title: "Find Resources", 
        description: "Directly connect to local jobs, housing, mental health support, and more." 
    },
];

export const HowItWorks = () => {
    const theme = useTheme();

    return (
        <Box sx={{ py: 6, bgcolor: theme.palette.background.default }}>
            <Container maxWidth="lg">
                <Typography 
                    variant="h3" 
                    align="center" 
                    sx={{ mb: 6, fontWeight: 700, color: theme.palette.primary.dark }}
                >
                    How Product of My Environment Works
                </Typography>
                <Grid container spacing={4} justifyContent="center"> {/* Added justifyContent="center" */}
                    {steps.map((step, index) => {
                        const Icon = step.icon;
                        return (
                            <Grid item xs={12} sm={6} md={4} key={index}>
                                <Paper 
                                    elevation={3} 
                                    sx={{ 
                                        p: 4, 
                                        textAlign: 'center', // Ensures text/icons are centered within the card
                                        height: '100%', 
                                        borderRadius: 3 
                                    }}
                                >
                                    <Icon sx={{ fontSize: 48, color: theme.palette.secondary.main, mb: 2 }} />
                                    <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
                                        {step.title}
                                    </Typography>
                                    <Typography color="text.secondary">
                                        {step.description}
                                    </Typography>
                                </Paper>
                            </Grid>
                        );
                    })}
                </Grid>
            </Container>
        </Box>
    );
};